import React from 'react';

const Nevada = () => {
  return (
    <div>
      
    </div>
  );
}

export default Nevada;
